/* Caratable home: sale countdown, ship-by dates, deal tabs.
   Loaded by the announcement bar (site-wide timer) and the ct-home-* sections; runs once. */
(() => {
  if (window.ctHome) return;
  window.ctHome = true;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad = (n) => String(n).padStart(2, "0");
  const ny = (opts) => Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", hour12: false, ...opts }).formatToParts(new Date()).map((x) => [x.type, +x.value || 0]));

  /* countdown: to the sale's end date (Theme settings > Offers), or with none to the next midnight in New York (daily reset) */
  const endsRaw = document.documentElement.dataset.ctSaleEnds;
  const endsM = endsRaw && endsRaw.trim().match(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}) ?([+-]\d{2})(\d{2})$/);
  const endsAt = endsM ? Date.parse(`${endsM[1]}T${endsM[2]}:00${endsM[3]}:${endsM[4]}`) : NaN;
  const tick = () => {
    let left;
    if (endsRaw) {
      /* a mistyped date shows no clock rather than a wrong one */
      left = isNaN(endsAt) ? 0 : Math.floor((endsAt - Date.now()) / 1000);
      if (left <= 0) { document.documentElement.classList.add("ct-sale-over"); return; }
    } else {
      const p = ny({ hour: "2-digit", minute: "2-digit", second: "2-digit" });
      left = 86400 - ((p.hour % 24) * 3600 + p.minute * 60 + p.second);
    }
    const hh = pad(Math.floor(left / 3600)), mm = pad(Math.floor((left % 3600) / 60)), ss = pad(left % 60);
    const days = Math.floor(left / 86400);
    const t = `${days ? days + "d " + pad(Math.floor(left % 86400 / 3600)) : hh}:${mm}:${ss}`;
    $$("[data-ct-timer]").forEach((el) => { el.textContent = t; });
    $$("[data-ct-hh]").forEach((el) => { el.textContent = hh; });
    $$("[data-ct-mm]").forEach((el) => { el.textContent = mm; });
    $$("[data-ct-ss]").forEach((el) => { el.textContent = ss; });
  };

  /* order today -> ships after N days (pushed off weekends) -> arrives after M business days */
  const dates = () => {
    $$("[data-ct-ship]").forEach((root) => {
      const days = +root.dataset.ctShip || 21, transit = +root.dataset.ctTransit || 2;
      const p = ny({ year: "numeric", month: "numeric", day: "numeric" });
      const D = (y, m, d) => new Date(Date.UTC(y, m, d));
      const plus = (d, n) => D(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n);
      /* same US holidays as the product page timeline (theme.js) */
      const nth = (y, m, wd, k) => { const f = D(y, m, 1); return plus(f, ((wd - f.getUTCDay() + 7) % 7) + 7 * (k - 1)); };
      const last = (y, m, wd) => { const l = D(y, m + 1, 0); return plus(l, -((l.getUTCDay() - wd + 7) % 7)); };
      const obs = (d) => (d.getUTCDay() === 6 ? plus(d, -1) : d.getUTCDay() === 0 ? plus(d, 1) : d);
      const hol = {};
      const hols = (y) => hol[y] || (hol[y] = new Set([obs(D(y, 0, 1)), last(y, 4, 1), obs(D(y, 6, 4)), nth(y, 8, 1, 1), nth(y, 10, 4, 4), obs(D(y, 11, 25)), obs(D(y + 1, 0, 1))].map((d) => +d)));
      const biz = (d) => d.getUTCDay() % 6 !== 0 && !hols(d.getUTCFullYear()).has(+d);
      let ship = plus(D(p.year, p.month - 1, p.day), days);
      while (!biz(ship)) ship = plus(ship, 1);
      let arrive = ship, n = 0;
      while (n < transit) { arrive = plus(arrive, 1); if (biz(arrive)) n++; }
      const fmt = (d) => d.toLocaleDateString("en-US", { timeZone: "UTC", month: "short", day: "numeric" });
      $$("[data-ct-shipby]", root).forEach((el) => { el.textContent = fmt(ship); });
      $$("[data-ct-arrives]", root).forEach((el) => { el.textContent = fmt(arrive); });
      $$("[data-ct-dates]", root).forEach((el) => { el.hidden = false; });
    });
  };

  /* deal tabs */
  const tabs = () => {
    $$("[data-ct-tabs]").forEach((sec) => {
      const btns = $$("[data-ct-tab]", sec), panels = $$("[data-ct-panel]", sec);
      btns.forEach((b) => b.addEventListener("click", () => {
        btns.forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
        panels.forEach((p) => { p.hidden = p.dataset.ctPanel !== b.dataset.ctTab; });
      }));
    });
  };

  const init = () => { tick(); setInterval(tick, 1000); dates(); tabs(); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", () => { tick(); dates(); tabs(); });
})();
